import React from 'react';
import Icon from './Lifetime.svg';

const ShareIcon = ({height='100%', width='100%', color='primary'}) => {
	return <Icon height={height} width={width} color={color} aria-hidden={true} />;
};

export default ShareIcon;
